/* eslint-disable react/no-multi-comp */
import React from 'react'
import { FormattedMessage } from 'react-intl'

export const EMPTY_LIST_TITLE = (
    <FormattedMessage
        id='battle_rooms.empty_list.title'
        defaultMessage='Отряды не найдены'
    />
)

export const EMPTY_LIST_CREATE_UNIT_MESSAGE = (
    <FormattedMessage
        id='battle_rooms.empty_list.create_unit_title'
        defaultMessage='Чтобы участвовать в сражениях, создайте отряд.'
    />
)

export const BATTLES_ONLY_ON_X_LEVEL = (
    <FormattedMessage
        id='battle_rooms.empty_list.battles_only_on_x_level'
        defaultMessage='Наступления доступны только на X дивизионе'
    />
)

// Buttons

export const BUTTON_TOOLTIP_ID = 'EMPTY_LIST_BUTTON_TOOLTIP_ID'

export const UPDATE_BUTTON_CAPTION = (
    <FormattedMessage
        id='battle_rooms.empty_list.update_button_caption'
        defaultMessage='Обновить список'
    />
)

export const SHOW_BUTTON_CAPTION = (
    <FormattedMessage
        id='battle_rooms.empty_list.show_button'
        defaultMessage='Показать'
    />
)

export const SHOW_BUTTON_TOOLTIP_TITLE = (
    <FormattedMessage
        id='battle_rooms.empty_list.show_button_tooltip_title'
        defaultMessage='Показать'
    />
)

export const SHOW_BUTTON_TOOLTIP_MESSAGE = (
    <FormattedMessage
        id='battle_rooms.empty_list.show_button_tooltip'
        defaultMessage='Нажмите, чтобы показать отряды для сражений во всех дивизионах.'
    />
)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/UnitsList/components/EmptyList/constants.jsx